/* eslint-disable */
import OktaVue, { navigationGuard } from '@okta/okta-vue'
import LoginCallback from '@/components/LoginCallback.vue'
import { OktaAuth } from '@okta/okta-auth-js'
import inject from 'vue'
import { reactive } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import HomeDefault from '@/components/HomeDefault.vue'
import HelpHome from '@/components/helpPages/HelpHome.vue'
import HelpAoeEduLicensing from '@/components/helpPages/HelpAoeEduLicensing.vue'
import HelpAhsCIR from '../components/helpPages/HelpAhsCIR.vue'
import HelpAhsDDSD from '../components/helpPages/HelpAhsDDSD.vue'
import HelpAhsRefugee from '../components/helpPages/HelpAhsRefugee.vue'
import HelpGeneralMFa from '@/components/helpPages/HelpGeneralMfa.vue'
import HelpGeneralMFaPolicy from '@/components/helpPages/HelpGeneralMfaPolicy.vue'
import HelpDcfGaaps from '@/components/helpPages/HelpDcfGaaps.vue'
import HelpAnrDec from '@/components/helpPages/HelpAnrDec.vue'
import HelpBenefits from '@/components/helpPages/HelpBenefits.vue'
import HelpAotS1111 from '@/components/helpPages/HelpAotS1111.vue'
import HelpTims from '@/components/helpPages/HelpTims.vue'
import Help802Smiles from '@/components/helpPages/Help802Smiles.vue'
import HelpCdd from '@/components/helpPages/HelpCdd.vue'
import HelpDll from '@/components/helpPages/HelpDll.vue'
import HelpVdol from '@/components/helpPages/HelpVdol.vue'
import HelpDmvReg from '@/components/helpPages/HelpDmvReg.vue'
import TownClerks from '@/components/helpPages/TownClerks.vue'
import HelpVdhPassword from '@/components/helpPages/HelpVdhPassword.vue'
import HelpAotHaul from '@/components/helpPages/HelpAotHaul.vue'
import HelpAhsVdhPatientProfile from '@/components/helpPages/HelpAhsVdhPatientProfile.vue'
import HelpAhsVdhEBRS from '@/components/helpPages/HelpAhsVdhEBRS.vue'
import HelpAhsVdhEDRS from '@/components/helpPages/HelpAhsVdhEDRS.vue'
import HelpAhsVdhVRIMS from '@/components/helpPages/HelpAhsVdhVRIMS.vue'
import HelpAhsVdhMedBoard from '@/components/helpPages/HelpAhsVdhMedBoard.vue'
import HelpAhsVdhVPMS from '@/components/helpPages/HelpAhsVdhVPMS.vue'
import HelpAoAVtBuys from '@/components/helpPages/HelpAoaVtBuys.vue'
import Welcome from '@/components/Welcome.vue'
import WelcomeVdhPartner from '@/components/WelcomeVdhPartner.vue'
import Logout from '@/components/Logout.vue'
import HelpAoeEdPlan from '../components/helpPages/HelpAoeEdPlan.vue'
import HelpAhsVdhWic from '../components/helpPages/HelpAhsVdhWic.vue'
import HelpAoeIndTuition from '../components/helpPages/HelpAoeIndTuition.vue'


let envLinks = {
    env: process.env.VUE_APP_ENV,
    infoApp: process.env.VUE_APP_APP_DOMAIN,
    linkAdmin: process.env.VUE_APP_LINK_OKTA_ADMIN,
    linkUploader: process.env.VUE_APP_LINK_UPLOADER,
    linkOnlineApp: process.env.VUE_APP_LINK_ONLINE_APP,
    linkMyBenefits: process.env.VUE_APP_LINK_MYBENEFITS,
    aotHaul: process.env.VUE_APP_AOT_VTHAUL,
    bizPortal: process.env.VUE_APP_BIZ_PORTAL,
    cddFamily: process.env.VUE_APP_CDD_FAMILY,
    cddProgram: process.env.VUE_APP_CDD_PROGRAM,
    dcfGAAPS: process.env.VUE_APP_DCF_GAAPS,
    dllLicensing: process.env.VUE_APP_DLL_LICENSING,
    dllEducation: process.env.VUE_APP_DLL_EDUCATION,
    dll802Spirits: process.env.VUE_APP_DLL_802SPIRITS,
    aoeLaces: process.env.VUE_APP_AOE_LACES,
    aotTrips: process.env.VUE_APP_AOT_TRIPS,
    aotUtilPermitting: process.env.VUE_APP_AOT_GEOWORKS,
    anrDecLoansGrants: process.env.VUE_APP_ANR_DEC_LOANS_GRANTS,
    aotTripsRollout: process.env.VUE_APP_AOT_TRIPS_ROLLOUT,
    laborClaimants: process.env.VUE_APP_LABORCLAIMS,
    laborUiFiling: process.env.VUE_APP_LABORUI,
    oktaDomain: process.env.VUE_APP_OKTA_DOMAIN,
    searchTerms: (process.env.VUE_APP_SEARCH_TERMS || '').split(','),
    linkVdhTims: process.env.VUE_APP_VDH_TIMS,
    linkVdhSmiles: process.env.VUE_APP_VDH_SMILES,
    aoaVtBuysHome: process.env.VUE_APP_AOA_VTBUYS,
    aoeEduLicensingHome: process.env.VUE_APP_AOE_VLSE,
    aoeEdPlan: process.env.VUE_APP_AOE_EDPLAN,
    aoeIndTuition: process.env.VUE_APP_AOE_INDTUITION,
    linkAHS_Cir: process.env.VUE_APP_AHS_CIR,
    linkAHS_DDSD: process.env.VUE_APP_AHS_DDSD,
    linkAHS_Refugee: process.env.VUE_APP_AHS_REFUGEE,
    linkAHS_VDH_PatientProfile: process.env.VUE_APP_AHS_VDH_PATIENTPROFILE,
    linkAHS_VDH_EDRS: process.env.VUE_APP_AHS_VDH_EDRS,
    linkAHS_VDH_EBRS: process.env.VUE_APP_AHS_VDH_EBRS,
    linkAHS_VDH_VRIMS: process.env.VUE_APP_AHS_VDH_VRIMS,
    linkAHS_VDH_MedBoard: process.env.VUE_APP_AHS_VDH_MEDBOARD,
    linkAHS_VDH_VPMS: process.env.VUE_APP_AHS_VDH_VPMS,
    linkAHS_VDH_WIC: process.env.VUE_APP_AHS_VDH_WIC,
    vdolEmployVtClaimant: process.env.VUE_APP_VDOL_EMPLOYVT_CLAIMANT,
    vdolEmployVtEmployer: process.env.VUE_APP_VDOL_EMPLOYVT_EMPLOYER,
}


// Last filter state the user had on the home page, so the "Return to
// info.my.vermont.gov" links on help pages can send them back to the same
// mix of tiles instead of the unfiltered list.
export const lastHomeQuery = reactive({ value: {} })

export function homeLink() {
    return { path: '/', query: lastHomeQuery.value }
}

let router = createRouter({
    history: createWebHistory(),
    scrollBehavior(to, from, savedPosition) {
        return { top: 0 }
    },
    routes: [
        {
            path: '/',
            name: 'HomeDefault',
            component: HomeDefault,
            props: {
                envLinks: envLinks,
            },
        },
        {
            path: '/help-home',
            name: 'HelpHome',
            component: HelpHome,
            props: {
                envLinks: envLinks,
            },
        },
        {
            path: '/help-mfa',
            name: 'HelpGeneralMFa',
            component: HelpGeneralMFa,
            props: {
                envLinks: envLinks,
            },
        },
        {
            path: '/help-mfa-policy',
            name: 'HelpGeneralMFaPolicy',
            component: HelpGeneralMFaPolicy,
            props: {
                envLinks: envLinks,
            },
        },
        {
            path: '/help-vtbuys',
            name: 'HelpAoaVtBuys',
            component: HelpAoAVtBuys,
            props: {
                envLinks: envLinks,
            },
        },
        {
            path: '/help-vthaul',
            name: 'HelpAotHaul',
            component: HelpAotHaul,
            props: {
                envLinks: envLinks,
            },
        },
        {
            path: '/help-ahs-cir',
            name: 'HelpAhsCIR',
            component: HelpAhsCIR,
            props: {
                envLinks: envLinks,
            },
        },
        {
            path: '/help-ahs-refugee',
            name: 'HelpAhsRefugee',
            component: HelpAhsRefugee,
            props: {
                envLinks: envLinks,
            },
        },
        {
            path: '/help-ahs-ddsd',
            name: 'HelpAhsDDSD',
            component: HelpAhsDDSD,
            props: {
                envLinks: envLinks,
            },
        },
        {
            path: '/help-tims',
            name: 'HelpTims',
            component: HelpTims,
            props: {
                envLinks: envLinks,
            },
        },
        {
            path: '/help-edu-licensing',
            name: 'HelpAoeEduLicensing',
            component: HelpAoeEduLicensing,
            props: {
                envLinks: envLinks,
            },
        },
        {
            path: '/help-edu-edplan',
            name: 'HelpAoeEdPlan',
            component: HelpAoeEdPlan,
            props: {
                envLinks: envLinks,
            },
        },
        {
            path: '/help-aoe-indtuition',
            name: 'HelpAoeIndTuition',
            component: HelpAoeIndTuition,
            props: {
                envLinks: envLinks,
            },
        },
        {
            path: '/help-smiles',
            name: 'HelpSmiles',
            component: Help802Smiles,
            props: {
                envLinks: envLinks,
            },
        },
        {
            path: '/help-benefits',
            name: 'HelpBenefits',
            component: HelpBenefits,
            props: {
                envLinks: envLinks,
            },
        },
        {
            path: '/help-cdd',
            name: 'HelpCdd',
            component: HelpCdd,
            props: {
                envLinks: envLinks,
            },
        },
        {
            path: '/help-cdd-providers',
            name: 'HelpCddProvider',
            component: HelpCdd,
            props: {
                envLinks: envLinks,
            },
        },
        {
            path: '/help-dcf-gaaps',
            name: 'HelpDcfGaaps',
            component: HelpDcfGaaps,
            props: {
                envLinks: envLinks,
            },
        },
        {
            path: '/help-dll',
            name: 'HelpDll',
            component: HelpDll,
            props: {
                envLinks: envLinks,
            },
        },
        {
            path: '/help-vdol',
            name: 'HelpVdol',
            component: HelpVdol,
            props: {
                envLinks: envLinks,
            },
        },
        {
            path: '/help-dmv',
            name: 'HelpDmvReg',
            component: HelpDmvReg,
            props: {
                envLinks: envLinks,
            },
        },
        {
            path: '/help-aot-s1111',
            name: 'HelpAotS1111',
            component: HelpAotS1111,
            props: {
                envLinks: envLinks,
            },
        }, {
            path: '/help-anr-dec',
            name: 'HelpAnrDec',
            component: HelpAnrDec,
            props: {
                envLinks: envLinks,
            },
        },
        {
            path: '/townclerks',
            name: 'TownClerks',
            component: TownClerks,
            props: {
                envLinks: envLinks,
            },
        },
        {
            path: '/help-vdh-password',
            name: 'HelpVdhPassword',
            component: HelpVdhPassword,
        },
        {
            path: '/help-ahs-vdh-patientprofile',
            name: 'HelpAhsVdhPatientProfile',
            component: HelpAhsVdhPatientProfile,
            props: {
                envLinks: envLinks,
            },
        },
        {
            path: '/help-ahs-vdh-ebrs',
            name: 'HelpAhsVdhEBRS',
            component: HelpAhsVdhEBRS,
            props: {
                envLinks: envLinks,
            },
        },
        {
            path: '/help-ahs-vdh-edrs',
            name: 'HelpAhsVdhEDRS',
            component: HelpAhsVdhEDRS,
            props: {
                envLinks: envLinks,
            },
        },
        {
            path: '/help-ahs-vdh-vrims',
            name: 'HelpAhsVdhVRIMS',
            component: HelpAhsVdhVRIMS,
            props: {
                envLinks: envLinks,
            },
        },
        {
            path: '/help-ahs-vdh-vpms',
            name: 'HelpAhsVdhVPMS',
            component: HelpAhsVdhVPMS,
            props: {
                envLinks: envLinks,
            },
        },
        {
            path: '/help-ahs-vdh-vtbmpo',
            name: 'HelpAhsVdhMedBoard',
            component: HelpAhsVdhMedBoard,
            props: {
                envLinks: envLinks,
            },
        },
        {
            path: '/help-ahs-vdh-wic',
            name: 'HelpAhsVdhWic',
            component: HelpAhsVdhWic,
            props: {
                envLinks: envLinks,
            },
        },
        {
            path: '/callback',
            component: LoginCallback,
            meta: {
                onAuthError: { name: 'HomeDefault' }
            }
        },
        {
            path: '/welcome',
            name: 'Welcome',
            component: Welcome,
            props: {
                envLinks: envLinks,
            },
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/welcome-vdh-partner',
            name: 'WelcomeVdhPartner',
            component: WelcomeVdhPartner,
            props: {
                envLinks: envLinks,
            },
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/logout',
            name: 'Logout',
            component: Logout,
            props: {
                envLinks: envLinks,
            },
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: '/:pathMatch(.*)*',
            name: 'Default',
            component: HomeDefault,
            props: {
                envLinks: envLinks,
            },
        },
    ],
})

router.afterEach((to) => {
    if (to.path === '/') {
        lastHomeQuery.value = { ...to.query }
    }
})

router.beforeEach(navigationGuard)
export default router
